import { Sizes } from '@theme/globals/sizing';

const checkBox = {
  active: {},
  border: {
    color: 'gray-300',
    width: Sizes[2],
  },
  color: 'white',
  check: {
    radius: Sizes[8],
    thickness: Sizes[3],
    extend: ({
      theme,
      checked,
      indeterminate,
    }: {
      theme: { global: { colors: { [key: string]: string } } };
      checked: boolean;
      indeterminate: boolean;
    }) => `
      background-color: ${
        checked || indeterminate
          ? theme.global.colors['primary-500']
          : theme.global.colors.white
      };
      ${(checked || indeterminate) && 'border: none;'}
        `,
  },
  label: {
    align: 'start',
  },
  hover: {
    border: {
      color: 'brand',
    },
  },
  icon: {},
  icons: {},
  size: Sizes[24],
};

export default checkBox;
